import React, { useState, useEffect } from "react";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { id: "services", label: "Applications" },
  { id: "how-it-works", label: "Fonctionnement" },
  { id: "performance", label: "Performance" },
  { id: "about", label: "À propos" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="nx-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A1128]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-home-link"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="focus:outline-none"
        >
          <Logo />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className="text-sm text-slate-300 hover:text-white transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="nav-cta-button"
            onClick={() => window.dispatchEvent(new Event("nx:open-demo"))}
            className="bg-[#5BC4D1] text-[#060B19] font-semibold px-5 py-2.5 rounded-full hover:bg-[#3DA9B6] transition-colors text-sm"
          >
            Renseignements
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#0A1128]/95 backdrop-blur-xl border-b border-white/10 px-6 py-6 flex flex-col gap-4"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className="text-left text-slate-200 hover:text-[#5BC4D1] py-2 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta-button"
            onClick={() => {
              setOpen(false);
              window.dispatchEvent(new Event("nx:open-demo"));
            }}
            className="bg-[#5BC4D1] text-[#060B19] font-semibold px-5 py-3 rounded-full text-sm mt-2"
          >
            Renseignements
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
